import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { getSeriesConfig, inLastStep } from '../../selectors/ui';
import { getOrderTotal } from '../../selectors/cart';
import { GoogleAnalytics4 } from './GoogleAnalytics4';
import { getMainEvent, getSelectedEvent } from '@b/checkout/selectors/event';
import { getSeriesOption } from '@v/series/selectors/eventSeries';

export class GoogleFloodlight extends GoogleAnalytics4 {
    constructor(props) {
        super(props);

        if (props.config?.floodlight_id) {
            // subscribe to hooks
            this.props.addReservationCompleteHook(this.onReservationComplete);
        }
    }

    onReservationComplete = () => {
        const reservationSessionKey = `Floodlight_${this.props.config.floodlight_id}_onReservationComplete_${this.props.confirmationNumber}`;

        const sent = sessionStorage.getItem(reservationSessionKey);
        if (!sent) {
            // purchase event
            this.reportWholeReservationEvent('purchase', {
                transaction_id: this.props.confirmationNumber,
            });
            sessionStorage.setItem(reservationSessionKey,'1');
        }
    }
}

const mapStateToProps = state => {
    const mainEvent = getMainEvent(state)?.event;
    const selectedEvent = getSelectedEvent(state)?.event;

    return {
        mainEvent: mainEvent ?? null,
        selectedEvent: selectedEvent ?? null,
        payments: state.payment.payments,
        confirmationNumber: state.reservation.confirmation_number,
        inLastStep: inLastStep(state),
        currency: state.reservation.currency || 'USD',
        orderTotal: getOrderTotal(state)?.amount ?? 0,
        tickets: state.tickets.tickets,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
        hasInsurance: !!state.reservation.hasInsurance,
        priceLevels: state.priceLevel.levels,
        bundles: state.bundles.bundles,
        products: state.products.products,
        reservationCurrency: state.reservation.currency,
        overlayVisible: state.ui.overlay,
        calendarDisplayType: getSeriesConfig(state).calendarType,
        calendarOnListing: !!getSeriesOption("calendarOnListing", false)(state),
        listingSlug: state.ui.listingSlug,
        skipMembership: state.ui.skipMembership,
    }
}

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}

GoogleFloodlight.propTypes = {
    config: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleFloodlight)
